import paycoUtils from '@/assets/js/utils'

interface IOrder {

  orderId: string,
  orderType: string,
  orderCompleteYmd: string,
  repReceiverName: string,
  ticketCount: number,
  cancelableYn: string,

  productName: string,
  productImageUrl: string
}

class Order {
  constructor(args: IOrder) {
    return Object.assign(this, args);
  }

  get isCancelable(): boolean {
    return paycoUtils.convertYnToBoolean(this.cancelableYn);
  }

  get orderTypeString(): string {
    return this.orderType == 'GIFT' ? '선물' : '주문';
  }

  get productInfo(): { productImageUrl: string; productName: string } {
    return {
      productName: this.productName,
      productImageUrl: this.productImageUrl,
    }
  }
}

interface Order extends IOrder {
}

export default Order;